import * as React from 'react';
import { styled } from '@mui/material/styles';
import { TableContainer, TableHead, TableRow, Paper, TableBody, Table, TableCell, tableCellClasses } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#99b3d98c",
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
export default function KhasraTables({ formData }) {

  return (
    <TableContainer component={Paper}>
    <Table sx={{ minWidth: 700 }} aria-label="customized table">
      <TableHead>
        <TableRow>
          <StyledTableCell>Sr. No</StyledTableCell>
          <StyledTableCell align="right">Khasra No</StyledTableCell>
          <StyledTableCell align="right">Area</StyledTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
      {formData?.khasraArea?.map((item, index) => (
          <StyledTableRow key={item.id || index}>
            <StyledTableCell component="th" scope="row">
              {index + 1}
            </StyledTableCell>
            <StyledTableCell align="right">{item.khasra || 'N/A'}</StyledTableCell>
            <StyledTableCell align="right">{item.area || 'N/A'}</StyledTableCell>
          </StyledTableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
  );
}
